import React, { useEffect, useState, useCallback, useRef } from "react";
import SideNavbar from '../../../components/SideNavbar';
import Navbar from '../../../components/Navbar';
import * as XLSX from "xlsx";
import { useAuth } from '../../../AuthContext';
import TableSkeleton from '../../../components/TableSkeleton';

// firebase
import { app, db } from "../../../firebaseConfig";
import { doc, getDoc, collection, query, where, getDocs, Timestamp, addDoc, updateDoc, writeBatch, getCountFromServer, DocumentData, limit, documentId, } from 'firebase/firestore';
import { getAuth } from "firebase/auth";

// Redux
import {
    setLeadProperty,
    clearCustomReportsFilterProps,
} from '../../../redux/customReportsPropsSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/store';

// Functions
import { fetchLeads, LeadData, exportLeadsToExcel } from '../Admin/Function/LeadFunctions'
import Toast from "../../../components/Toast";
import ReportModals from "../../../components/modals/ReportModals";
import getCurrentScreen from "../../../Helper/GetScreen";
import DatePicker from "react-datepicker";
import { reset, setDashboardProps } from "../../../redux/leadManagementDashboardSclice";

export interface Lead {
    id: string;
    name: string;
    email: string;
    createdAt?: Date;
    followUpDate?: Date;
    number: string;
    assignedTo: string;
    adminNotes?: string;
    sourceId?: string;
    stageId?: string;
    stateId?: string;
    statusId?: string;
    distribution: number;
    isActive: boolean;
    isNewEntry?: boolean;
    followUp?: string;
    updatedAt?: Date;
}
interface User {
    id: string;
    name: string;
    lastName: string;
    email: string;
    distribution?: number;
}
interface ExcelRow {
    FirstName: string;
    LastName: string;
    Email?: string;
    PhoneNumber: string;
}
interface LeadUpdateData extends DocumentData {
    name: string;
    number: string;
    email: string;
    phoneNumber: string;
    assignedTo: string;
    adminNotes: string;
    sourceId: string;
    stageId: string;
    stateId: string;
    statusId: string;
    updatedAt: Timestamp;
    updatedBy: string;
    createdAt?: Timestamp;
    followUpDate?: Timestamp;
    followUp?: string;
}
interface ToastProps {
    message: string;
    isError?: boolean; // Make sure this is optional
    onClose: () => void;
    show: boolean;
}

interface LeadAdmissionStatus {
    level: any;
    admissionStatus: string;
}

interface LeadSource {
    source: string;
}

interface LeadStage {
    stage: string;
    priority: number;
    color: string;
}

interface LeadState {
    state: string;
    makeInactive: boolean;
}

interface LeadStatus {
    status: string;
    priority: number;
    color: string;
}

interface LeadWelcomeCallByAdmissionTeamStatus {
    welcomeCallByAdmissionTeamStatus: string;
}

interface LeadVisaFileProcessingStatus {
    visaFileProcessingStatus: string;
}

interface LeadApplicationMovedStatus {
    applicationMovedStatus: string;
}

interface LeadOfferLetterStatus {
    offerLetterStatus: string;
}

interface LeadFeePaymentStatus {
    feePaymentStatus: string;
}

interface LeadFileSubmissionStatus {
    fileSubmissionStatus: string;
}

interface LeadFollowUpStatus {
    followUpStatus: string;
}

interface LeadCampaign {
    campaign: string;
}

interface PreferredStream {
    preferredStream: string;
}

interface SubAgent {
    id: string;
    name: string;
    email: string;
    isActive: boolean;
}

interface Destination {
    name: string;
}

interface leadDateFilter {
    startDate: string;
    endDate: string;
}

interface leadUpdatedFilter {
    startDate: string;
    endDate: string;
}

interface DocumentWithId {
    id: string;
    data: any;
}

interface SettingsBoxesLayoutProps {
    tabId: string;
    // Add other required props
}

const Reports = () => {
    const { userData, currentUser, isAdmin, isManager, isStaff } = useAuth();
    const currentScreen = getCurrentScreen(useAppSelector(state => state.screen.currentScreen), isAdmin, isManager, isStaff);
    const [isReportPopupOpen, setReportPopupOpen] = useState(false);


    const dispatch = useAppDispatch();

    // collapse state for filter section
    const [isCollapsedFilter, setIsCollapsedFilter] = useState(true);

    const selectedLeadValue = useAppSelector(state => state.customReportsProps.leadStates);
    const selectedSourceValue = useAppSelector(state => state.customReportsProps.leadSources);
    const selectedStageValue = useAppSelector(state => state.customReportsProps.leadStages);
    const selectedStatusValue = useAppSelector(state => state.customReportsProps.leadStatuses);
    const selectedAdmissionStatusValue = useAppSelector(state => state.customReportsProps.leadAdmissionStatuses);
    const selectedWelcomeCallByAdmissionTeamStatusValue = useAppSelector(state => state.customReportsProps.leadWelcomeCallByAdmissionTeamStatuses);
    const selectedVisaProcessingStatusValue = useAppSelector(state => state.customReportsProps.leadVisaProcessingStatuses);
    const selectedApplicationMovedStatusValue = useAppSelector(state => state.customReportsProps.leadApplicationMovedStatuses);
    const selectedConditionalOfferLetterStatusValue = useAppSelector(state => state.customReportsProps.leadConditionalOfferLetterStatuses);
    const selectedUnConditionalOfferLetterStatusValue = useAppSelector(state => state.customReportsProps.leadUnConditionalOfferLetterStatuses);
    const selectedFeePaymentStatusValue = useAppSelector(state => state.customReportsProps.leadFeePaymentStatuses);
    const selectedFileSubmissionStatusValue = useAppSelector(state => state.customReportsProps.leadFileSubmissionStatuses);
    const selectedFollowUpStatusValue = useAppSelector(state => state.customReportsProps.leadFollowUpStatuses);
    const selectedAssigneeOptionsValue = useAppSelector(state => state.customReportsProps.leadAssigneeOptions);
    const selectedCampaignOptionsValue = useAppSelector(state => state.customReportsProps.leadCampaignOptions);
    const selectedPrefferedStreamsValue = useAppSelector(state => state.customReportsProps.leadPrefferedStreams);
    const selectedDestinationsValue = useAppSelector(state => state.customReportsProps.leadDestinations);
    const createdAtStartDateValue = useAppSelector(state => state.customReportsProps.createdAtStartDate);
    const createdAtEndDateValue = useAppSelector(state => state.customReportsProps.createdAtEndDate);
    const updatedAtStartDateValue = useAppSelector(state => state.customReportsProps.updatedAtStartDate)
    const updatedAtEndDateValue = useAppSelector(state => state.customReportsProps.updatedAtEndDate)
    const selectedSubAgentOptionsValue = useAppSelector(state => state.customReportsProps.leadSubAgentOptions);
    const selectedIntakeYearValue = useAppSelector(state => state.customReportsProps.leadIntakeYear)
    const selectedIntakeMonthValue = useAppSelector(state => state.customReportsProps.leadIntakeMonth)


    // useEffect execution order control
    const [firstEffectDone, setFirstEffectDone] = useState(false);

    const itemsPerPage = 10;

    const closePopup = () => {
        setReportPopupOpen(false);
    };

    const [leads, setLeads] = useState<Lead[]>([]);
    const [newLead, setNewLead] = useState<Partial<LeadData>>({});
    const [editingId, setEditingId] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [companyId, setCompanyId] = useState<string | null>(null);
    const [stages, setStages] = useState<{ id: string; stage: string }[]>([]);
    const [states, setStates] = useState<{ id: string; state: string }[]>([]);
    const [file, setFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [statuses, setStatuses] = useState<{ id: string; status: string }[]>([]);
    const [assignedToOptions, setAssignedToOptions] = useState<User[]>([]);
    const [pageSize, setPageSize] = useState<number>(10);
    const leadsPerPage = pageSize;
    const auth = getAuth(app);
    const [totalLeadsCount, setTotalLeadsCount] = useState<number>(0);
    const [lastUpdated, setLastUpdated] = useState<string>('');
    const totalPages = Math.ceil(totalLeadsCount / leadsPerPage);
    const [totalDistribution, setTotalDistribution] = useState(0);
    const [showError, setShowError] = useState(false);
    const [processedLeadsCount, setProcessedLeadsCount] = useState<number | null>(null);
    const [sources, setSources] = useState<{ id: string; source: string }[]>([]);
    const [campaigns, setCampaigns] = useState<{ id: string; campaign: string }[]>([]);
    const [password, setPassword] = useState('');
    const [isCopied, setIsCopied] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const isCollapsed = useAppSelector(state => state.sidebar.isCollapsed);

    // Filter states
    const [leadStates, setLeadStates] = useState<DocumentWithId[]>([]);
    const [leadStatuses, setLeadStatuses] = useState<DocumentWithId[]>([]);
    const [leadStages, setLeadStages] = useState<DocumentWithId[]>([]);
    const [leadSources, setLeadSources] = useState<DocumentWithId[]>([]);
    const [admissionStatuses, setAdmissionStatuses] = useState<DocumentWithId[]>([]);
    const [welcomeCallByAdmissionTeamStatuses, setWelcomeCallByAdmissionTeamStatuses] = useState<DocumentWithId[]>([]);
    const [visaProcessingStatuses, setVisaProcessingStatuses] = useState<DocumentWithId[]>([]);
    const [applicationMovedStatuses, setApplicationMovedStatuses] = useState<DocumentWithId[]>([]);
    const [conditionalofferLetterStatuses, setConditionalOfferLetterStatuses] = useState<DocumentWithId[]>([]);
    const [unConditionalofferLetterStatuses, setUnConditionalOfferLetterStatuses] = useState<DocumentWithId[]>([]);
    const [feePaymentStatuses, setFeePaymentStatuses] = useState<DocumentWithId[]>([]);
    const [fileSubmissionStatuses, setFileSubmissionStatuses] = useState<DocumentWithId[]>([]);
    const followUpStatuses: DocumentWithId[] = [
        { id: 'false', data: { followUpStatus: 'False' } },
        { id: 'true', data: { followUpStatus: 'True' } }
    ];
    const [assigneeOptions, setAssigneeOptions] = useState<DocumentWithId[]>([]);
    const [campaignOptions, setCampaignOptions] = useState<DocumentWithId[]>([]);
    const [managerTeamOptions, setManagerTeamOptions] = useState<string[]>([]);
    const [prefferedStreams, setPrefferedStreams] = useState<DocumentWithId[]>([]);
    const [destinations, setDestinations] = useState<DocumentWithId[]>([]);

    const [subAgentOptions, setSubAgentOptions] = useState<DocumentWithId[]>([]);


    // selected items
    const [selectedLeadStates, setSelectedLeadStates] = useState<string[]>([]);
    const [selectedLeadStatuses, setSelectedLeadStatuses] = useState<string[]>([]);
    const [selectedLeadStages, setSelectedLeadStages] = useState<string[]>([]);
    const [selectedLeadSources, setSelectedLeadSources] = useState<string[]>([]);
    const [selectedAdmissionStatuses, setSelectedAdmissionStatuses] = useState<string[]>([]);
    const [selectedWelcomeCallByAdmissionTeamStatuses, setSelectedWelcomeCallByAdmissionTeamStatuses] = useState<string[]>([]);
    const [selectedVisaProcessingStatuses, setSelectedVisaProcessingStatuses] = useState<string[]>([]);
    const [selectedApplicationMovedStatuses, setSelectedApplicationMovedStatuses] = useState<string[]>([]);
    const [selectedConditionalOfferLetterStatuses, setSelectedConditionalOfferLetterStatuses] = useState<string[]>([]);
    const [selectedUnConditionalOfferLetterStatuses, setSelectedUnConditionalOfferLetterStatuses] = useState<string[]>([]);
    const [selectedFeePaymentStatuses, setSelectedFeePaymentStatuses] = useState<string[]>([]);
    const [selectedFileSubmissionStatuses, setSelectedFileSubmissionStatuses] = useState<string[]>([]);
    const [selectedFollowUpStatuses, setSelectedFollowUpStatuses] = useState<string[]>([]);
    const [selectedAssigneeOptions, setSelectedAssigneeOptions] = useState<string[]>([]);
    const [selectedCampaignOptions, setSelectedCampaignOptions] = useState<string[]>([]);
    const [selectedPrefferedStreams, setSelectedPrefferedStreams] = useState<string[]>([]);
    const [selectedDestinations, setSelectedDestinations] = useState<string[]>([]);
    const [selectedStartDate, setSelectedStartDate] = useState<string[]>([]);
    const [selectedEndDate, setSelectedEndDate] = useState<string[]>([]);

    const [selectedIntakeYear, setSelectedIntakeYear] = useState<string[]>([])
    const [selectedIntakeMonth, setSelectedIntakeMonth] = useState<string[]>([])


    const [selectedUpdatedAtStartDate, setSelectedUpdatedAtStartDate] = useState<string[]>([]);
    const [selectedUpdatedAtEndDate, setSelectedUpdatedAtEndDate] = useState<string[]>([]);

    const [selectedSubAgentOptions, setSelectedSubAgentOptions] = useState<string[]>([]);

    const [selectedColumns, setSelectedColumns] = useState<string[]>([
        "name", "email", "status" // example default columns
    ]);


    const [customizeOpen, setCustomizeOpen] = useState(false);

    const leadManagementDashboardProps = useAppSelector(state => state.leadManagementDashboard);


    const customTableProps = {
        "Name": "name",
        "Phone": "phone",
        "Created At": "createdAt",
        "Updated At": "updatedAt",
        "Source": "source",
        "Campaign": "campaign",
        "Assigned To": "assignedTo",
        "Sub Agent": "subAgent",
        "Admission Status": "admissionStatus",
        "Stage": "stage",
        "Priority": "priority",
        "Follow Up": "followUp",
        "Actions": "actions",
    };


    // tabs
    const [activeTab, setActiveTab] = useState('regular');

    // report type
    const [reportType, setReportType] = useState('');

    const clearAllFilters = (e: React.MouseEvent) => {
        e.stopPropagation();
        dispatch(clearCustomReportsFilterProps());
    };

    // useEffect to set the redux state for the selected items
    useEffect(() => {
        setSelectedLeadSources(selectedSourceValue);
        setSelectedLeadStages(selectedStageValue);
        setSelectedLeadStates(selectedLeadValue);
        setSelectedLeadStatuses(selectedStatusValue);
        setSelectedAdmissionStatuses(selectedAdmissionStatusValue);
        setSelectedWelcomeCallByAdmissionTeamStatuses(selectedWelcomeCallByAdmissionTeamStatusValue);
        setSelectedVisaProcessingStatuses(selectedVisaProcessingStatusValue);
        setSelectedApplicationMovedStatuses(selectedApplicationMovedStatusValue);
        setSelectedConditionalOfferLetterStatuses(selectedConditionalOfferLetterStatusValue);
        setSelectedUnConditionalOfferLetterStatuses(selectedUnConditionalOfferLetterStatusValue);
        setSelectedFeePaymentStatuses(selectedFeePaymentStatusValue);
        setSelectedFileSubmissionStatuses(selectedFileSubmissionStatusValue);
        setSelectedFollowUpStatuses(selectedFollowUpStatusValue);
        setSelectedAssigneeOptions(selectedAssigneeOptionsValue);
        setSelectedCampaignOptions(selectedCampaignOptionsValue);
        setSelectedPrefferedStreams(selectedPrefferedStreamsValue);
        setSelectedDestinations(selectedDestinationsValue);
        setSelectedStartDate(createdAtStartDateValue);
        setSelectedEndDate(createdAtEndDateValue);
        setSelectedUpdatedAtStartDate(updatedAtStartDateValue);
        setSelectedUpdatedAtEndDate(updatedAtEndDateValue)
        setSelectedSubAgentOptions(selectedSubAgentOptionsValue)
        setSelectedIntakeYear(selectedIntakeYearValue)
        setSelectedIntakeMonth(selectedIntakeMonthValue)
    }, [firstEffectDone, selectedSourceValue, selectedStageValue, selectedLeadValue,
        selectedStatusValue, selectedAdmissionStatusValue, selectedWelcomeCallByAdmissionTeamStatusValue,
        selectedVisaProcessingStatusValue, selectedApplicationMovedStatusValue, selectedConditionalOfferLetterStatusValue,
        selectedUnConditionalOfferLetterStatusValue, selectedFeePaymentStatusValue, selectedFileSubmissionStatusValue,
        selectedFollowUpStatusValue, selectedAssigneeOptionsValue, selectedCampaignOptionsValue, selectedPrefferedStreamsValue,
        selectedDestinationsValue, createdAtStartDateValue, createdAtEndDateValue, updatedAtStartDateValue, updatedAtEndDateValue, selectedIntakeYearValue, selectedIntakeMonthValue, selectedSubAgentOptionsValue]);

    const RenderSettingsBox = (
        title: string,
        type: string,
        items: DocumentWithId[],
        selectedItems: string[],
        selectedItems2: string[] | null,
        reduxKey1: string,
        reduxKey2: string | null,
        getDisplayText: (item: any) => string,
        getColor?: (item: any) => string | undefined
    ) => {
        const dispatch = useAppDispatch();

        const dropdownRef = useRef<HTMLDivElement>(null);
        const customDatePopupRef = useRef<HTMLDivElement>(null);
        const [localDropdownOpen, setLocalDropdownOpen] = useState<boolean>(false);
        const [localSearchQuery, setLocalSearchQuery] = useState('');
        const [inputValue, setInputValue] = useState('');
        const [highlightedIndex, setHighlightedIndex] = useState<number>(-1);
        const [filteredItems, setFilteredItems] = useState<DocumentWithId[]>([]);
        const [isSearching, setIsSearching] = useState<boolean>(false);
        const [tempDateValue, setTempDateValue] = useState<string>('');
        const [dateRangeStart, setDateRangeStart] = useState<Date | null>(null);
        const [dateRangeEnd, setDateRangeEnd] = useState<Date | null>(null);
        const [openDatePicker, setOpenDatePicker] = useState<'created' | 'updated' | null>(null);

        // For intake month and year filter
        const [selectedMonth, setSelectedMonth] = useState<string | null>(null);
        const [selectedYear, setSelectedYear] = useState<string | null>(null);
        const months = [
            { value: 1, name: 'January' },
            { value: 2, name: 'February' },
            { value: 3, name: 'March' },
            { value: 4, name: 'April' },
            { value: 5, name: 'May' },
            { value: 6, name: 'June' },
            { value: 7, name: 'July' },
            { value: 8, name: 'August' },
            { value: 9, name: 'September' },
            { value: 10, name: 'October' },
            { value: 11, name: 'November' },
            { value: 12, name: 'December' }
        ];
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i + ''); // 2020-2030

        useEffect(() => {
            const handleClickOutside = (event: MouseEvent) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                    setLocalDropdownOpen(false);
                    setOpenDatePicker(null);
                }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }, []);

        // Sync dateRangeStart and dateRangeEnd with selectedItems when they change
        useEffect(() => {
            if (type === 'date' && selectedItems && selectedItems.length > 0 && selectedItems2 && selectedItems2.length > 0) {
                const startDate = new Date(selectedItems[0]);
                const endDate = new Date(selectedItems2[0]);

                if (!dateRangeStart || startDate.getTime() !== dateRangeStart.getTime()) {
                    setDateRangeStart(startDate);
                }
                if (!dateRangeEnd || endDate.getTime() !== dateRangeEnd.getTime()) {
                    setDateRangeEnd(endDate);
                }
            }
        }, [selectedItems, selectedItems2, type]);

        // Handle intake month/year selection
        const handleIntakeMonthYearSelection = () => {
            console.log(selectedMonth, selectedYear);

            if (selectedMonth || selectedYear) {
                // Create a date range for the entire selected month
                // const startDate = new Date(selectedYear, selectedMonth - 1, 1);
                // const endDate = new Date(selectedYear, selectedMonth, 0); // Last day of month

                if (reduxKey1 && selectedMonth !== null) {
                    console.log("<<<<<<<<<<<<<<<<<<<<", reduxKey1, [selectedMonth]);

                    dispatch(setLeadProperty({
                        key: reduxKey1,
                        value: [selectedMonth]
                    }));
                }

                if (reduxKey2 && selectedYear !== null) {
                    console.log("<<<<<<<<<<<<<<<<<<<<", reduxKey2, selectedYear);

                    dispatch(setLeadProperty({
                        key: reduxKey2,
                        value: [selectedYear]
                    }));
                }

                setLocalDropdownOpen(false);
            }
        };

        // Clear intake month/year selection
        const clearIntakeMonthYearSelection = () => {
            setSelectedMonth(null);
            setSelectedYear(null);
            dispatch(setLeadProperty({ key: reduxKey1, value: [] }));
            if (reduxKey2) {
                dispatch(setLeadProperty({ key: reduxKey2, value: [] }));
            }
        };

        const filterItems = (items: DocumentWithId[], getDisplayText: (item: any) => string) => {
            if (title === 'Destinations' && reduxKey1 === 'leadDestinations') {
                return filteredItems;
            }

            if (!localSearchQuery) return items;
            return items.filter(item =>
                getDisplayText(item.data).toLowerCase().includes(localSearchQuery.toLowerCase())
            );
        };

        const handleLocalSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
            e.stopPropagation();
            const value = e.target.value;
            setInputValue(value);
            setLocalSearchQuery(value);
            setLocalDropdownOpen(true);

            if (title === 'Destinations' && reduxKey1 === 'leadDestinations' && value.length >= 2) {
                setIsSearching(true);
                try {
                    const countriesRef = collection(db, 'countries');
                    const searchValue = value.toUpperCase();
                    const q = query(
                        countriesRef,
                        where('name', '>=', searchValue),
                        where('name', '<=', searchValue + '\uf8ff'),
                        limit(20)
                    );

                    const querySnapshot = await getDocs(q);
                    const countriesData = querySnapshot.docs.map(doc => ({
                        id: doc.id,
                        data: { name: doc.data().name } as Destination
                    }));

                    setFilteredItems(countriesData);
                } catch (error) {
                    console.error('Error searching countries:', error);
                    setFilteredItems([]);
                } finally {
                    setIsSearching(false);
                }
            } else if (title === 'Destinations' && value.length < 2) {
                setFilteredItems([]);
            }
        }

        const handleSelection = (id: string) => {
            if (type === 'date') {
                setTempDateValue(id);
            } else {
                dispatch(setLeadProperty({ key: reduxKey1, value: [id] }));
                setLocalDropdownOpen(false);
                setLocalSearchQuery('');
                const selectedItem = items.find(item => item?.id === id);
                setInputValue(selectedItem ? getDisplayText(selectedItem.data) : '');
            }
        };

        const handleDateSelection = (from: string | Date, to: string | Date) => {
            // Always store as ISO string for Redux
            const fromStr = from instanceof Date ? from.toISOString() : from;
            const toStr = to instanceof Date ? to.toISOString() : to;
            dispatch(setLeadProperty({ key: reduxKey1, value: [fromStr] }));
            dispatch(setLeadProperty({ key: reduxKey2 || '', value: [toStr] }));
            const storageKey = title === 'Created Date' ? 'createdDateRange' : 'updatedDateRange';
            sessionStorage.setItem(storageKey, JSON.stringify({ start: fromStr, end: toStr }));
            setTempDateValue('');
        };

        const clearDateRangeSelection = (item: 'created' | 'updated' | null = null) => {
            setDateRangeStart(null);
            setDateRangeEnd(null);
            dispatch(setLeadProperty({ key: reduxKey1, value: [] }));
            if (reduxKey2) {
                dispatch(setLeadProperty({ key: reduxKey2, value: [] }));
            }

            const storageKey = title === 'Created Date' ? 'createdDateRange' : 'updatedDateRange';
            sessionStorage.removeItem(storageKey);

            setOpenDatePicker(item);
        };

        const handleApplyDateSelection = () => {
            if (dateRangeStart && dateRangeEnd) {
                handleDateSelection(dateRangeStart.toISOString(), dateRangeEnd.toISOString());
                setOpenDatePicker(null);
                setLocalDropdownOpen(false);
                setLocalSearchQuery('');
            }
        };

        const clearDataSelection = () => {
            dispatch(setLeadProperty({ key: reduxKey1, value: [] }));
            setInputValue('');
            setLocalSearchQuery('');
            setTempDateValue('');
            setLocalDropdownOpen(false);
        }

        const cachedSelectedItemName = useRef<string>('');

        const getSelectedItemText = () => {
            if (selectedItems && selectedItems.length > 0) {
                if (title === 'Destinations' && reduxKey1 === 'leadDestinations') {
                    const selectedItem = filteredItems?.find(item => item?.id === selectedItems[0]);
                    if (selectedItem) {
                        return getDisplayText(selectedItem.data);
                    }

                    if (cachedSelectedItemName.current) {
                        return cachedSelectedItemName.current;
                    }

                    return 'Loading...';
                } else {
                    const selectedItem = items?.find(item => item?.id === selectedItems[0]);
                    return selectedItem ? getDisplayText(selectedItem.data) : '';
                }
            }
            return inputValue;
        };

        useEffect(() => {
            if (title === 'Destinations' && reduxKey1 === 'leadDestinations' &&
                selectedItems && selectedItems.length > 0 &&
                !cachedSelectedItemName.current) {

                const selectedInFiltered = filteredItems.find(item => item.id === selectedItems[0]);
                if (selectedInFiltered) {
                    cachedSelectedItemName.current = getDisplayText(selectedInFiltered.data);
                    return;
                }

                const fetchSelectedCountry = async () => {
                    try {
                        const countryDoc = await getDoc(doc(db, 'countries', selectedItems[0]));
                        if (countryDoc.exists()) {
                            cachedSelectedItemName.current = countryDoc.data().name;
                            setInputValue(cachedSelectedItemName.current);
                        }
                    } catch (error) {
                        console.error('Error fetching selected country:', error);
                    }
                };

                fetchSelectedCountry();
            }
        }, [selectedItems, title, reduxKey1, filteredItems]);

        const handleInputClick = async () => {
            setLocalDropdownOpen(true);

            if (!inputValue && type !== 'date') {
                const selectedItem = items.find(item => item?.id === selectedItems[0]);
                if (selectedItem) {
                    setInputValue('');
                    setLocalSearchQuery('');
                }
            }

            if (title === 'Destinations' && reduxKey1 === 'leadDestinations') {
                setFilteredItems([]);
            }
        };

        const handleClear = (e: React.MouseEvent) => {
            e.stopPropagation();

            // Clear both Redux keys if they exist
            dispatch(setLeadProperty({ key: reduxKey1, value: [] }));
            if (reduxKey2) {
                dispatch(setLeadProperty({ key: reduxKey2, value: [] }));
            }

            // Clear local states
            setInputValue('');
            setLocalSearchQuery('');
            setTempDateValue('');

            // Clear date range states if this is a date filter
            if (type === 'date') {
                setDateRangeStart(null);
                setDateRangeEnd(null);
            }

            // Clear intake month/year if this is that type
            if (type === 'intake-month-year') {
                setSelectedMonth(null);
                setSelectedYear(null);
            }
        };

        const handleKeyDown = (e: React.KeyboardEvent) => {
            const filteredItems = filterItems(items, getDisplayText);

            if (!localDropdownOpen && (e.key === 'ArrowDown' || e.key === 'Enter')) {
                e.preventDefault();
                setLocalDropdownOpen(true);
                return;
            }

            if (!localDropdownOpen) return;

            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    setHighlightedIndex(prevIndex => {
                        if (prevIndex >= filteredItems.length - 1) {
                            return 0;
                        }
                        return prevIndex + 1;
                    });
                    break;

                case 'ArrowUp':
                    e.preventDefault();
                    setHighlightedIndex(prevIndex => {
                        if (prevIndex <= 0) {
                            return filteredItems.length - 1;
                        }
                        return prevIndex - 1;
                    });
                    break;

                case 'Enter':
                    e.preventDefault();
                    if (highlightedIndex >= 0 && highlightedIndex < filteredItems.length) {
                        handleSelection(filteredItems[highlightedIndex].id);
                    }
                    break;

                case 'Escape':
                    e.preventDefault();
                    setLocalDropdownOpen(false);
                    break;
            }
        };

        const scrollToHighlighted = (index: number) => {
            if (index < 0) return;

            setTimeout(() => {
                const highlightedElement = document.getElementById(`dropdown-item-${index}`);
                if (highlightedElement && dropdownRef.current) {
                    const dropdownList = dropdownRef.current.querySelector('.max-h-48');
                    if (dropdownList) {
                        const listRect = dropdownList.getBoundingClientRect();
                        const elementRect = highlightedElement.getBoundingClientRect();

                        if (elementRect.top < listRect.top) {
                            highlightedElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                        } else if (elementRect.bottom > listRect.bottom) {
                            highlightedElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                        }
                    }
                }
            }, 0);
        };

        useEffect(() => {
            scrollToHighlighted(highlightedIndex);
        }, [highlightedIndex]);

        return (
            <div ref={dropdownRef} className={`flex flex-col bg-white rounded-lg shadow-sm relative ${localDropdownOpen ? 'z-40' : 'z-0'}`}>
                <div className="px-2 py-1.5">
                    <label className="block text-[14px] font-medium text-gray-600 mb-0.5 font-Montserrat">{title}</label>
                    <div className="relative">
                        <div className="relative flex items-center">
                            {type === 'intake-month-year' ? (
                                <div className="relative w-full">
                                    <input
                                        type="text"
                                        className={`w-full h-8 px-2 py-1 border border-gray-200 rounded-md text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-all duration-200 font-Montserrat placeholder-gray-400 cursor-pointer`}
                                        title={title}
                                        value={
                                            (selectedItems && selectedItems.length > 0) || (selectedItems2 && selectedItems2.length > 0)
                                                ? `${selectedItems && selectedItems.length > 0 ? selectedItems[0] : ''} ${selectedItems2 && selectedItems2.length > 0 ? selectedItems2[0] : ''}`
                                                : "Select Intake Month & Year"
                                        }

                                        placeholder="Select..."
                                        readOnly
                                        onClick={() => setLocalDropdownOpen(true)}
                                    />

                                    <div className="absolute right-1.5 flex items-center space-x-0.5">
                                        {/* {(selectedItems.length > 0) && (
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    clearIntakeMonthYearSelection();
                                                }}
                                                className="p-0.5 hover:bg-gray-100 rounded-full transition-colors"
                                            >
                                                <svg className="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                            </button>
                                        )} */}
                                        {/* <button
                                            type="button"
                                            className="p-0.5 hover:bg-gray-100 rounded-full transition-colors"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setLocalDropdownOpen(!localDropdownOpen);
                                            }}
                                        >
                                            <svg
                                                className={`w-4 h-4 text-gray-400 transform transition-transform duration-200 ${localDropdownOpen ? 'rotate-180' : ''}`}
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </button> */}
                                    </div>
                                </div>
                            ) : type !== 'date' ? (
                                <input
                                    type={type}
                                    className={`w-full h-8 px-2 py-1 border border-gray-200 rounded-md text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-all duration-200 font-Montserrat placeholder-gray-400 ${type === 'date' && selectedItems.length > 0 ? '[&::-webkit-calendar-picker-indicator]:hidden' : ''
                                        }`}
                                    title={title}
                                    value={type === 'date' ? (tempDateValue || selectedItems[0] || '') : (localDropdownOpen ? localSearchQuery : getSelectedItemText())}
                                    placeholder="Select..."
                                    onClick={handleInputClick}
                                    onChange={(e) => {
                                        if (type === 'date') {
                                            handleSelection(e.target.value);
                                        } else {
                                            e.stopPropagation();
                                            setLocalSearchQuery(e.target.value);
                                            setInputValue(e.target.value);
                                            setLocalDropdownOpen(true);
                                        }
                                    }}
                                />
                            ) : (
                                <div className="relative w-full">
                                    <input
                                        type="text"
                                        className={`w-full h-8 px-2 py-1 border border-gray-200 rounded-md text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-all duration-200 font-Montserrat placeholder-gray-400 cursor-pointer`}
                                        title={title}
                                        value={selectedItems && selectedItems.length > 0 && selectedItems2 && selectedItems2.length > 0
                                            ? `${new Date(selectedItems[0]).toLocaleDateString()} - ${new Date(selectedItems2[0]).toLocaleDateString()}`
                                            : title === 'Created Date' ? "Select Create Date Range" : "Select Update Date Range"}
                                        placeholder="Select..."
                                        readOnly
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenDatePicker(title === 'Created Date' ? 'created' : 'updated');
                                        }}
                                    />

                                    {title === 'Created Date' && openDatePicker === 'created' && (
                                        <div
                                            ref={customDatePopupRef}
                                            className="absolute top-full right-0 mt-2 w-auto h-auto bg-white border rounded-3xl shadow-lg p-4 z-[5]"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <div className="flex justify-between items-center mb-2">
                                                <h3 className="text-[14px] font-normal leading-[20px] text-left">
                                                    Select Create Date Range
                                                </h3>
                                            </div>
                                            <div className="mb-1">
                                                <span className="text-[12px] font-normal leading-[16px] text-left">
                                                    <span className='font-medium'>Current: </span>
                                                    {selectedItems && selectedItems2 && selectedItems.length > 0 && selectedItems2.length > 0
                                                        ? `${new Date(selectedItems[0]).toLocaleDateString()} - ${new Date(selectedItems2[0]).toLocaleDateString()}`
                                                        : "Select Date Range"}
                                                </span>
                                                <div className="grid grid-cols-2 gap-2 mt-2">
                                                    <button onClick={() => {
                                                        setDateRangeStart(new Date());
                                                        setDateRangeEnd(new Date());
                                                    }} className="text-[12px] font-normal leading-[16px] text-left text-cyan-600">Today</button>
                                                    <button onClick={() => {
                                                        const start = new Date();
                                                        start.setDate(start.getDate() - 7);
                                                        const end = new Date();
                                                        setDateRangeStart(start);
                                                        setDateRangeEnd(end);
                                                    }} className="text-[12px] font-normal leading-[16px] text-left text-cyan-600">Last 7 Days</button>
                                                    <button onClick={() => {
                                                        const start = new Date();
                                                        start.setDate(start.getDate() - 30);
                                                        const end = new Date();
                                                        setDateRangeStart(start);
                                                        setDateRangeEnd(end);
                                                    }} className="text-[12px] font-normal leading-[16px] text-left text-cyan-600">Last 30 Days</button>
                                                    <button onClick={() => {
                                                        const start = new Date();
                                                        start.setDate(start.getDate() - 90);
                                                        const end = new Date();
                                                        setDateRangeStart(start);
                                                        setDateRangeEnd(end);
                                                    }} className="text-[12px] font-normal leading-[16px] text-left text-cyan-600">Last 90 Days</button>
                                                </div>
                                                <div
                                                    className="p-4 bg-white shadow-lg rounded-[12px]"
                                                    style={{ width: '100%', height: 'auto' }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <DatePicker
                                                        selected={dateRangeStart}
                                                        startDate={dateRangeStart ?? undefined}
                                                        endDate={dateRangeEnd ?? undefined}
                                                        selectsRange
                                                        onChange={(update) => {
                                                            const [start, end] = update;
                                                            setDateRangeStart(start);
                                                            setDateRangeEnd(end);
                                                        }}
                                                        inline
                                                        className="w-full h-full p-4 bg-gray-100 shadow-lg rounded-[12px] custom-calendar"
                                                        maxDate={new Date()}
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex justify-between mt-2">
                                                <button
                                                    className="px-8 py-2 text-white bg-black rounded-full"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setDateRangeStart(null);
                                                        setDateRangeEnd(null);
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                                <button
                                                    className="px-8 py-2 text-white bg-cyan-600 rounded-full"
                                                    onClick={() => {
                                                        if (dateRangeStart && dateRangeEnd) {
                                                            handleDateSelection(dateRangeStart.toISOString(), dateRangeEnd.toISOString());
                                                            setOpenDatePicker(null);
                                                            setLocalDropdownOpen(false);
                                                            setLocalSearchQuery('');
                                                        }
                                                    }}
                                                    disabled={!dateRangeStart || !dateRangeEnd}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {title === 'Updated Date' && openDatePicker === 'updated' && (
                                        <div
                                            ref={customDatePopupRef}
                                            className="absolute top-full right-0 mt-2 w-auto h-auto bg-white border rounded-3xl shadow-lg p-4 z-[5]"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <div className="flex justify-between items-center mb-2">
                                                <h3 className="text-[14px] font-normal leading-[20px] text-left">
                                                    Select Update Date Range
                                                </h3>
                                            </div>
                                            <div className="mb-1">
                                                <span className="text-[12px] font-normal leading-[16px] text-left">
                                                    <span className='font-medium'>Current: </span>
                                                    {selectedItems && selectedItems2 && selectedItems.length > 0 && selectedItems2.length > 0
                                                        ? `${new Date(selectedItems[0]).toLocaleDateString()} - ${new Date(selectedItems2[0]).toLocaleDateString()}`
                                                        : "Select Date Range"}
                                                </span>
                                                <div className="grid grid-cols-2 gap-2 mt-2">
                                                    <button onClick={() => {
                                                        setDateRangeStart(new Date());
                                                        setDateRangeEnd(new Date());
                                                    }} className="text-[12px] font-normal leading-[16px] text-left text-cyan-600">Today</button>
                                                    <button onClick={() => {
                                                        const start = new Date();
                                                        start.setDate(start.getDate() - 7);
                                                        const end = new Date();
                                                        setDateRangeStart(start);
                                                        setDateRangeEnd(end);
                                                    }} className="text-[12px] font-normal leading-[16px] text-left text-cyan-600">Last 7 Days</button>
                                                    <button onClick={() => {
                                                        const start = new Date();
                                                        start.setDate(start.getDate() - 30);
                                                        const end = new Date();
                                                        setDateRangeStart(start);
                                                        setDateRangeEnd(end);
                                                    }} className="text-[12px] font-normal leading-[16px] text-left text-cyan-600">Last 30 Days</button>
                                                    <button onClick={() => {
                                                        const start = new Date();
                                                        start.setDate(start.getDate() - 90);
                                                        const end = new Date();
                                                        setDateRangeStart(start);
                                                        setDateRangeEnd(end);
                                                    }} className="text-[12px] font-normal leading-[16px] text-left text-cyan-600">Last 90 Days</button>
                                                </div>
                                                <div
                                                    className="p-4 bg-white shadow-lg rounded-[12px]"
                                                    style={{ width: '100%', height: 'auto' }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <DatePicker
                                                        selected={dateRangeStart}
                                                        startDate={dateRangeStart ?? undefined}
                                                        endDate={dateRangeEnd ?? undefined}
                                                        selectsRange
                                                        onChange={(update) => {
                                                            const [start, end] = update;
                                                            setDateRangeStart(start);
                                                            setDateRangeEnd(end);
                                                        }}
                                                        inline
                                                        className="w-full h-full p-4 bg-gray-100 shadow-lg rounded-[12px] custom-calendar"
                                                        maxDate={new Date()}
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex justify-between mt-2">
                                                <button
                                                    className="px-8 py-2 text-white bg-black rounded-full"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        clearDateRangeSelection('updated');
                                                        setDateRangeStart(null);
                                                        setDateRangeEnd(null);
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                                <button
                                                    className="px-8 py-2 text-white bg-cyan-600 rounded-full"
                                                    onClick={() => {
                                                        if (dateRangeStart && dateRangeEnd) {
                                                            handleDateSelection(dateRangeStart.toISOString(), dateRangeEnd.toISOString());
                                                            setOpenDatePicker(null);
                                                            setLocalDropdownOpen(false);
                                                            setLocalSearchQuery('');
                                                        }
                                                    }}
                                                    disabled={!dateRangeStart || !dateRangeEnd}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="absolute right-1.5 flex items-center space-x-0.5">
                                {(selectedItems.length > 0 || selectedItems2 && selectedItems2.length > 0 || inputValue) && (
                                    <button
                                        onClick={handleClear}
                                        className="p-0.5 hover:bg-gray-100 rounded-full transition-colors"
                                    >
                                        <svg className="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                )}
                                {type !== 'date' && type !== 'intake-month-year' && (
                                    <button
                                        type="button"
                                        className="p-0.5 hover:bg-gray-100 rounded-full transition-colors"
                                        onClick={() => setLocalDropdownOpen(!localDropdownOpen)}
                                    >
                                        <svg
                                            className={`w-4 h-4 text-gray-400 transform transition-transform duration-200 ${localDropdownOpen ? 'rotate-180' : ''}`}
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Intake Month & Year Dropdown */}
                {localDropdownOpen && type === 'intake-month-year' && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden z-40 min-w-[250px]">
                        <div className="p-3">
                            <div className="grid grid-cols-2 gap-4">
                                {/* Month Selector */}
                                <div>
                                    <h4 className="text-xs font-medium mb-1">Month</h4>
                                    <div className="max-h-48 overflow-y-auto">
                                        {months.map((month) => (
                                            <div
                                                key={month.value}
                                                className={`px-2 py-1 text-xs cursor-pointer rounded ${selectedMonth === month.name ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-50'}`}
                                                onClick={() => setSelectedMonth(month.name)}
                                            >
                                                {month.name}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Year Selector */}
                                <div>
                                    <h4 className="text-xs font-medium mb-1">Year</h4>
                                    <div className="max-h-48 overflow-y-auto">
                                        {years.map((year) => (
                                            <div
                                                key={year}
                                                className={`px-2 py-1 text-xs cursor-pointer rounded ${selectedYear === year ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-50'}`}
                                                onClick={() => setSelectedYear(year)}
                                            >
                                                {year}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex justify-between mt-3 pt-2 border-t">
                                <button
                                    className="px-3 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded-md"
                                    onClick={() => {
                                        clearIntakeMonthYearSelection();
                                        setLocalDropdownOpen(false);
                                    }}
                                >
                                    Clear
                                </button>
                                <button
                                    className="px-3 py-1 text-xs bg-blue-500 hover:bg-blue-600 text-white rounded-md disabled:opacity-50"
                                    onClick={() => {
                                        handleIntakeMonthYearSelection();
                                    }}
                                    disabled={!selectedMonth && !selectedYear}
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {localDropdownOpen && type !== 'date' && type !== 'intake-month-year' && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden max-h-48 overflow-y-auto z-40 min-w-[200px]"
                    >
                        <div className="p-1">
                            <div className="px-2 py-1 sticky top-0 bg-white z-10 border-b border-gray-100">
                                <input
                                    type="text"
                                    className="w-full px-2 py-1 text-xs border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    placeholder={`Search ${title}...`}
                                    value={localSearchQuery}
                                    onChange={(e) => title === 'Destinations' && reduxKey1 === 'leadDestinations' ? handleLocalSearch(e) : setLocalSearchQuery(e.target.value)}
                                    onClick={(e) => e.stopPropagation()}
                                    onKeyDown={handleKeyDown}
                                    autoFocus
                                />
                            </div>
                            {isSearching && title === 'Destinations' && (
                                <div className="flex items-center px-2 py-1.5 cursor-pointer rounded-md transition-colors">
                                    <span className="text-xs font-Montserrat truncate flex-1">Searching...</span>
                                </div>
                            )}
                            {items.length === 0 && !isSearching && title !== 'Destinations' && (
                                <div
                                    className={`flex items-center px-2 py-1.5 cursor-pointer rounded-md transition-colors`}
                                >
                                    <span
                                        className="text-xs font-Montserrat truncate flex-1"
                                    >
                                        No {title} available
                                    </span>
                                </div>
                            )}
                            {title === 'Destinations' && (!localSearchQuery || localSearchQuery.length < 2) && (
                                <div className="flex items-center px-2 py-1.5 cursor-pointer rounded-md transition-colors">
                                    <span className="text-xs font-Montserrat truncate flex-1">
                                        {localSearchQuery.length === 0
                                            ? "Type to search for a country"
                                            : "Type at least 2 characters to search"}
                                    </span>
                                </div>
                            )}
                            {title === 'Destinations' ? (
                                filteredItems.length > 0 ? filteredItems.map((item, index) => (
                                    <div
                                        id={`dropdown-item-${index}`}
                                        key={item?.id}
                                        className={`flex items-center px-2 py-1.5 cursor-pointer rounded-md transition-colors ${highlightedIndex === index
                                            ? 'bg-blue-100 text-blue-800'
                                            : selectedItems?.includes(item?.id)
                                                ? 'bg-blue-50 text-blue-700'
                                                : 'hover:bg-gray-50'
                                            }`}
                                        onClick={() => handleSelection(item?.id)}
                                        onMouseEnter={() => setHighlightedIndex(index)}
                                    >
                                        <span
                                            className="text-xs font-Montserrat truncate flex-1"
                                        >
                                            {getDisplayText(item?.data)}
                                        </span>
                                        {selectedItems?.includes(item?.id) && (
                                            <svg className="w-4 h-4 text-blue-600 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                        )}
                                    </div>
                                )) : (!isSearching && localSearchQuery.length >= 2) ? (
                                    <div className="flex items-center px-2 py-1.5 cursor-pointer rounded-md transition-colors">
                                        <span className="text-xs font-Montserrat truncate flex-1">No countries found</span>
                                    </div>
                                ) : null
                            ) : filterItems(items, getDisplayText).length > 0 ? (
                                filterItems(items, getDisplayText).map((item, index) => (
                                    <div
                                        id={`dropdown-item-${index}`}
                                        key={item?.id}
                                        className={`flex items-center px-2 py-1.5 cursor-pointer rounded-md transition-colors ${highlightedIndex === index
                                            ? 'bg-blue-100 text-blue-800'
                                            : selectedItems?.includes(item?.id)
                                                ? 'bg-blue-50 text-blue-700'
                                                : 'hover:bg-gray-50'
                                            }`}
                                        onClick={() => handleSelection(item?.id)}
                                        onMouseEnter={() => setHighlightedIndex(index)}
                                    >
                                        <span
                                            className="text-xs font-Montserrat truncate flex-1"
                                            style={getColor ? { color: getColor(item?.data) } : undefined}
                                        >
                                            {getDisplayText(item?.data)}
                                        </span>
                                        {selectedItems?.includes(item?.id) && (
                                            <svg className="w-4 h-4 text-blue-600 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <div className="px-2 py-1.5 text-xs text-gray-500 text-center">
                                    No results found
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const RenderRegularReportBox = (
        title: string,
        discription: string,
    ) => {

        const handleSelection = (title: string) => {
            setReportType(title);
            setReportPopupOpen(true);
        }

        return (
            <div className={`max-w-sm p-6 border rounded-lg shadow-sm bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700`}>
                <a href="#">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{title}</h5>
                </a>
                <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{discription}</p>
                <a href="#"
                    style={{
                        background: 'linear-gradient(180deg, #FFA782 0%, #FC583D 100%)'
                    }}
                    className={`inline-flex items-center px-3 py-2 text-sm font-medium text-center rounded-lg text-white hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
                    onClick={() => handleSelection(title)}
                >
                    Options
                    <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                    </svg>
                </a>
            </div>
        );
    };

    const tabs = [
        { id: 'regular', label: 'Regular Reports', icon: 'user-group' },
        // { id: 'custom', label: 'Custom Reports', icon: 'document-text' },
    ];


    const SettingsBoxesLayout: React.FC<SettingsBoxesLayoutProps> = ({ tabId }) => {
        switch (tabId) {
            case 'regular':
                return (
                    <div className="grid grid-cols-5 gap-4">
                        {RenderRegularReportBox(
                            'Campaign Analytics',
                            'Comprehensive analysis of campaign performance through key metrics: call connectivity, conversion rates, and staff effectiveness.'
                        )}
                        {RenderRegularReportBox(
                            'Employee Analytics',
                            'Detailed analysis of employee performance based on call analytics.'
                        )}
                        {RenderRegularReportBox(
                            'Admission Analytics',
                            'Analysis of lead performance based on call analytics.'
                        )}
                    </div>
                );
            case 'custom':
                return (
                    <div className="grid grid-cols-4 gap-3 p-2">
                        {RenderSettingsBox(
                            'Lead Sources',
                            'text',
                            leadSources,
                            selectedLeadSources,
                            null,
                            'leadSources',
                            null,
                            (item: LeadSource) => item?.source
                        )}
                        {RenderSettingsBox(
                            'Lead Stages',
                            'text',
                            leadStages,
                            selectedLeadStages,
                            null,
                            'leadStages',
                            null,
                            (item: LeadStage) => item?.stage,
                            (item: LeadStage) => item?.color
                        )}
                        {RenderSettingsBox(
                            'Lead States',
                            'text',
                            leadStates,
                            selectedLeadStates,
                            null,
                            'leadStates',
                            null,
                            (item: LeadState) => item?.state
                        )}
                        {RenderSettingsBox(
                            'Lead Status',
                            'text',
                            leadStatuses,
                            selectedLeadStatuses,
                            null,
                            'leadStatuses',
                            null,
                            (item: LeadStatus) => item?.status,
                            (item: LeadStatus) => item?.color
                        )}
                        {RenderSettingsBox(
                            'Admission Status',
                            'text',
                            admissionStatuses,
                            selectedAdmissionStatuses,
                            null,
                            'leadAdmissionStatuses',
                            null,
                            (item: LeadAdmissionStatus) => item?.admissionStatus
                        )}
                        {RenderSettingsBox(
                            'Welcome Call Status',
                            'text',
                            welcomeCallByAdmissionTeamStatuses,
                            selectedWelcomeCallByAdmissionTeamStatuses,
                            null,
                            'leadWelcomeCallByAdmissionTeamStatuses',
                            null,
                            (item: LeadWelcomeCallByAdmissionTeamStatus) => item?.welcomeCallByAdmissionTeamStatus
                        )}
                        {RenderSettingsBox(
                            'Visa Processing',
                            'text',
                            visaProcessingStatuses,
                            selectedVisaProcessingStatuses,
                            null,
                            'leadVisaProcessingStatuses',
                            null,
                            (item: LeadVisaFileProcessingStatus) => item?.visaFileProcessingStatus
                        )}
                        {RenderSettingsBox(
                            'Application Status',
                            'text',
                            applicationMovedStatuses,
                            selectedApplicationMovedStatuses,
                            null,
                            'leadApplicationMovedStatuses',
                            null,
                            (item: LeadApplicationMovedStatus) => item?.applicationMovedStatus
                        )}
                        {RenderSettingsBox(
                            'Conditional Offer Letter Status',
                            'text',
                            conditionalofferLetterStatuses,
                            selectedConditionalOfferLetterStatuses,
                            null,
                            'leadConditionalOfferLetterStatuses',
                            null,
                            (item: LeadOfferLetterStatus) => item?.offerLetterStatus
                        )}
                        {RenderSettingsBox(
                            'Unconditional Offer Letter Status',
                            'text',
                            unConditionalofferLetterStatuses,
                            selectedUnConditionalOfferLetterStatuses,
                            null,
                            'leadUnConditionalOfferLetterStatuses',
                            null,
                            (item: LeadOfferLetterStatus) => item?.offerLetterStatus
                        )}
                        {RenderSettingsBox(
                            'Fee Payment Status',
                            'text',
                            feePaymentStatuses,
                            selectedFeePaymentStatuses,
                            null,
                            'leadFeePaymentStatuses',
                            null,
                            (item: LeadFeePaymentStatus) => item?.feePaymentStatus
                        )}
                        {RenderSettingsBox(
                            'File Submission Status',
                            'text',
                            fileSubmissionStatuses,
                            selectedFileSubmissionStatuses,
                            null,
                            'leadFileSubmissionStatuses',
                            null,
                            (item: LeadFileSubmissionStatus) => item?.fileSubmissionStatus
                        )}


                        {currentScreen !== "Staff" && RenderSettingsBox(
                            'Assignee Options',
                            'text',
                            assigneeOptions,
                            selectedAssigneeOptions,
                            null,
                            'leadAssigneeOptions',
                            null,
                            (item: User) => item?.name
                        )}

                        {/* work in */}

                        {RenderSettingsBox(
                            'Sub Agent Options',
                            'text',
                            subAgentOptions,
                            selectedSubAgentOptions,
                            null,
                            'leadSubAgentOptions',
                            null,
                            (item: User) => item?.name
                        )}


                        {RenderSettingsBox(
                            'Follow Up Status',
                            'text',
                            followUpStatuses,
                            selectedFollowUpStatuses,
                            null,
                            'leadFollowUpStatuses',
                            null,
                            (item: LeadFollowUpStatus) => item?.followUpStatus
                        )}
                        {RenderSettingsBox(
                            'Campaign Options',
                            'text',
                            campaignOptions,
                            selectedCampaignOptions,
                            null,
                            'leadCampaignOptions',
                            null,
                            (item: LeadCampaign) => item?.campaign
                        )}
                        {RenderSettingsBox(
                            'Preferred Stream',
                            'text',
                            prefferedStreams,
                            selectedPrefferedStreams,
                            null,
                            'leadPrefferedStreams',
                            null,
                            (item: PreferredStream) => item?.preferredStream
                        )}
                        {RenderSettingsBox(
                            'Destinations',
                            'text',
                            destinations,
                            selectedDestinations,
                            null,
                            'leadDestinations',
                            null,
                            (item: Destination) => item?.name
                        )}

                        {RenderSettingsBox(
                            'Intake Month & Year',
                            'intake-month-year',
                            [],
                            selectedIntakeMonth,
                            selectedIntakeYear,
                            'leadIntakeMonth',
                            'leadIntakeYear',
                            (item: any) => item?.toString()
                        )}



                        {RenderSettingsBox(
                            'Created Date',
                            'date',
                            [],
                            selectedStartDate,
                            selectedEndDate,
                            'createdAtStartDate',
                            'createdAtEndDate',
                            (item: leadDateFilter) => item?.startDate
                        )}


                        {RenderSettingsBox(
                            'Updated Date',
                            'date',
                            [],
                            selectedUpdatedAtStartDate,
                            selectedUpdatedAtEndDate,
                            'updatedAtStartDate',
                            'updatedAtEndDate',
                            (item: leadUpdatedFilter) => item?.startDate
                        )}







                    </div>
                );
            case 'payment':
                return (
                    <div className="grid grid-cols-5 gap-4">
                    </div>
                );
            default:
                return null;
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch admission statuses
                const admissionStatusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadAdmissionStatus`));
                setAdmissionStatuses(admissionStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadAdmissionStatus
                }))
                    .sort((a, b) => {
                        return a.data.level - b.data.level;
                    })
                );

                // Fetch lead sources
                const leadSourcesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadSources`));
                setLeadSources(leadSourcesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadSource
                }))
                    .sort((a, b) => a.data.source.localeCompare(b.data.source))
                );

                // Fetch lead stages
                const leadStagesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadStages`));
                setLeadStages(leadStagesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadStage
                }))
                    .sort((a, b) => {
                        return a.data.priority - b.data.priority;
                    })
                )

                // Fetch lead states
                const leadStatesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadStates`));
                setLeadStates(leadStatesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadState
                }))
                    .sort((a, b) => a.data.state.localeCompare(b.data.state))
                );

                // Fetch lead statuses
                const leadStatusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadStatuses`));
                setLeadStatuses(leadStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadStatus
                }))
                    .sort((a, b) => {
                        return a.data.priority - b.data.priority;
                    })
                );

                // Fetch welcome call statuses
                const welcomeCallByAdmissionTeamStatusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadWelcomeCallByAdmissionTeamStatus`));
                setWelcomeCallByAdmissionTeamStatuses(welcomeCallByAdmissionTeamStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadWelcomeCallByAdmissionTeamStatus
                }))
                    .sort((a, b) => a.data.welcomeCallByAdmissionTeamStatus.localeCompare(b.data.welcomeCallByAdmissionTeamStatus))
                );

                // Fetch visa processing statuses
                const visaProcessingStatusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadVisaFileProcessingStatus`));
                setVisaProcessingStatuses(visaProcessingStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadVisaFileProcessingStatus
                }))
                    .sort((a, b) => a.data.visaFileProcessingStatus.localeCompare(b.data.visaFileProcessingStatus))
                );

                // Fetch application moved statuses
                const applicationMovedStatusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadApplicationMovedStatus`));
                setApplicationMovedStatuses(applicationMovedStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadApplicationMovedStatus
                }))
                    .sort((a, b) => a.data.applicationMovedStatus.localeCompare(b.data.applicationMovedStatus))
                );

                // Fetch offer letter statuses
                const offerLetterStatusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadOfferLetterStatus`));
                setConditionalOfferLetterStatuses(offerLetterStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadOfferLetterStatus
                }))
                    .sort((a, b) => a.data.offerLetterStatus.localeCompare(b.data.offerLetterStatus))
                );

                setUnConditionalOfferLetterStatuses(offerLetterStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadOfferLetterStatus
                }))
                    .sort((a, b) => a.data.offerLetterStatus.localeCompare(b.data.offerLetterStatus))
                );

                // Fetch fee payment statuses
                const feePaymentStatusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadFeePaymentStatus`));
                setFeePaymentStatuses(feePaymentStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadFeePaymentStatus
                }))
                    .sort((a, b) => a.data.feePaymentStatus.localeCompare(b.data.feePaymentStatus))
                );

                // Fetch file submission statuses
                const fileSubmissionStatusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadFileSubmissionStatus`));
                setFileSubmissionStatuses(fileSubmissionStatusesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadFileSubmissionStatus
                }))
                    .sort((a, b) => a.data.fileSubmissionStatus.localeCompare(b.data.fileSubmissionStatus))
                );

                // fetch campaign options where isActive is true
                const campaignOptionsSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadCampaigns`));
                setCampaignOptions(campaignOptionsSnapshot.docs.filter(doc => doc.data().isActive).map(doc => ({
                    id: doc.id,
                    data: doc.data() as LeadCampaign
                }))
                    .sort((a, b) => a.data.campaign.localeCompare(b.data.campaign))
                );

                // fetch preffered stream
                const prefferedStreamsSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/preferredStreams`));
                setPrefferedStreams(prefferedStreamsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as PreferredStream
                }))
                    .sort((a, b) => a.data.preferredStream.localeCompare(b.data.preferredStream))
                );

                // Fetch sub agent options
                const subAgentOptionsSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/subAgents`));
                const subAgentOptions = subAgentOptionsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data() as SubAgent
                }));
                // console.log('subAgentOptions', subAgentOptions);
                setSubAgentOptions(subAgentOptions);

                // We'll load destinations/countries on-demand when searching, not all at once
                // Initialize with an empty array instead of fetching all ~200 countries
                setDestinations([]);

                // Fetch assignee options
                let usersQuery = query(
                    collection(db, "users"),
                    where("companyId", "==", userData?.companyId)
                );

                if (isAdmin && currentScreen === 'Admin') {
                    usersQuery = query(
                        collection(db, "users"),
                        where("companyId", "==", userData?.companyId),
                    );
                } else if (isManager && currentScreen === 'Manager') {
                    usersQuery = query(
                        collection(db, "users"),
                        where("companyId", "==", userData?.companyId),
                        where("managerIds", "array-contains", currentUser?.uid)
                    );

                    const users = await getDocs(usersQuery);
                    const managerTeam = users.docs.map(doc => doc.id);
                    setManagerTeamOptions(managerTeam);
                } else if (isStaff && currentScreen === 'Staff') {
                    setSelectedAssigneeOptions([currentUser ? currentUser?.uid : '']);
                }

                const usersSnapshot = await getDocs(usersQuery);
                const users = usersSnapshot.docs.map(doc => {
                    const data = doc.data();
                    return {
                        id: doc.id,
                        data: {
                            name: data.name,
                            email: data.email || '',
                        }
                    };
                });
                setAssigneeOptions(users);
                setFirstEffectDone(true);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [userData?.companyId]);


    useEffect(() => {
        const fetchCompanyId = async () => {
            const user = auth.currentUser;
            if (user) {
                const userDocRef = doc(db, "users", user.uid);
                const userDocSnap = await getDoc(userDocRef);
                if (userDocSnap.exists()) {
                    const userData = userDocSnap.data();
                    setCompanyId(userData.companyId);
                } else {
                    console.error("User document not found");
                }
            }
        };
        fetchCompanyId();
    }, [auth]);

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const statesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadStates`));
                const statusesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadStatuses`));
                const stagesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadStages`));
                const sourcesSnapshot = await getDocs(collection(db, `companies/${userData?.companyId}/leadSources`));
                const fetchedStages = stagesSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    stage: doc.data().stage,
                }));
                const fetchedStates = statesSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    state: doc.data().state,
                }));
                const fetchedStatuses = statusesSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    status: doc.data().status,
                }));
                const fetchedSources = sourcesSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    source: doc.data().source,
                }));
                setSources(fetchedSources);
                setStates(fetchedStates);
                setStatuses(fetchedStatuses);
                setStages(fetchedStages);
            } catch (error) {
                console.error("Error fetching dropdown data:", error);
            }
        };
        fetchDropdownData();
    }, []);

    const fetchAssignedToOptions = useCallback(async () => {
        if (!companyId) return;
        try {
            const usersQuery = query(
                collection(db, "users"),
                where("companyId", "==", companyId)
            );
            const usersSnapshot = await getDocs(usersQuery);
            const users = usersSnapshot.docs.map((doc) => {
                const data = doc.data();
                return {
                    id: doc.id,
                    name: data.name,
                    lastName: data.lastName || '',
                    email: data.email || '',
                    distribution: data.distribution || 0,
                };
            });
            const distributedUsers = distributeEqually(users);
            setAssignedToOptions(distributedUsers);
        }
        catch (error) {
            console.error("Error fetching users:", error);
        }
    }, [companyId]);

    useEffect(() => { fetchAssignedToOptions(); }, [fetchAssignedToOptions]);

    function convertToDate(value: Date | Timestamp): Date {
        if (value instanceof Timestamp) {
            return value.toDate(); // Convert Timestamp to Date
        }
        return new Date(value); // Handle number or other Date-compatible types
    }


    const getStatusCircleColor = (status: string) => {
        switch (status) {
            case 'Low Priority':
                return 'bg-red-300';
            case 'Meduim Priority':
                return 'bg-blue-200';
            case 'High Priority':
                return 'bg-black';
            default:
                return 'bg-transperant';
        }
    };

    const distributeLeadsPrecisely = (users: User[], totalUnassignedLeads: number) => {
        const leadAllocation: { [userId: string]: { baseLeads: number, remainder: number } } = {};
        users.forEach(user => {
            if (user.distribution) {
                const baseLeads = Math.floor((user.distribution / 100) * totalUnassignedLeads);
                const remainder = (user.distribution / 100) * totalUnassignedLeads - baseLeads;
                leadAllocation[user.id] = {
                    baseLeads,
                    remainder
                };
            }
        });
        const remainingSpotsToFill = totalUnassignedLeads -
            Object.values(leadAllocation).reduce((sum, alloc) => sum + alloc.baseLeads, 0);
        const usersWithRemainders = Object.entries(leadAllocation)
            .filter(([_, alloc]) => alloc.remainder > 0)
            .sort((a, b) => b[1].remainder - a[1].remainder);
        for (let i = 0; i < remainingSpotsToFill && i < usersWithRemainders.length; i++) {
            const [userId] = usersWithRemainders[i];
            leadAllocation[userId].baseLeads += 1;
        }
        return leadAllocation;
    };


    const distributeEqually = (users: any[]) => {
        const equalShare = Math.floor(100 / users.length);
        const remainder = 100 % users.length;
        return users.map((user, index) => ({
            ...user,
            distribution: index < remainder ? equalShare + 1 : equalShare,
        }));
    };

    const [leadsData, setLeadsData] = useState<LeadData[]>([]);
    const [hasMore, setHasMore] = useState(true);
    const [lastDocument, setLastDocument] = useState<{
        id: string;
        leadDate: Timestamp;
    } | null>(null);



    const [currentPage, setCurrentPage] = useState<number>(1);
    // const indexOfLastLead = currentPage * leadsPerPage;
    // const indexOfFirstLead = indexOfLastLead - leadsPerPage;
    // const currentLeads = leadsData.slice(indexOfFirstLead, indexOfLastLead);

    const handlePageChange = (pageNumber: number) => {
        if (pageNumber < 1 || pageNumber > totalPages || (pageNumber > currentPage && !hasMore)) {
            return;
        }

        setCurrentPage(pageNumber);
        fetchPageData(pageNumber);

        // store the current page in session storage
        sessionStorage.setItem('currentPage', pageNumber.toString());
        sessionStorage.setItem('cursorId', lastDocument?.id || '');
    };

    const handlePageSizeChange = (newPageSize: number) => {
        setPageSize(newPageSize);
        // Clear existing data to prevent confusion when showing a new page size
        setLeadsData([]);
        // Reset pagination state
        setLastDocument(null);
        setHasMore(true);

        // store the current page in session storage
        sessionStorage.setItem('currentPage', JSON.stringify(1));
    }

    // Helper function to fetch data for a specific page
    const fetchPageData = (pageNum: number) => {

        // console.log("intake month", selectedIntakeMonth);

        // Always fetch new data when changing pages
        // This ensures we're getting the correct data for the page
        fetchLeadsdata(false, pageNum, {
            selectedLeadSources: selectedLeadSources,
            selectedLeadStates: selectedLeadStates,
            selectedLeadStages: selectedLeadStages,
            selectedLeadStatuses: selectedLeadStatuses,
            selectedAdmissionStatuses: selectedAdmissionStatuses,
            selectedWelcomeCallByAdmissionTeamStatuses: selectedWelcomeCallByAdmissionTeamStatuses,
            selectedVisaProcessingStatuses: selectedVisaProcessingStatuses,
            selectedApplicationMovedStatuses: selectedApplicationMovedStatuses,
            selectedConditionalOfferLetterStatuses: selectedConditionalOfferLetterStatuses,
            selectedUnConditionalOfferLetterStatuses: selectedUnConditionalOfferLetterStatuses,
            selectedFeePaymentStatuses: selectedFeePaymentStatuses,
            selectedFileSubmissionStatuses: selectedFileSubmissionStatuses,
            selectedFollowUpStatuses: selectedFollowUpStatuses,
            selectedSubAgentOptions: selectedSubAgentOptions,
            selectedCampaignOptions: selectedCampaignOptions,
            selectedPrefferedStreams: selectedPrefferedStreams,
            selectedDestinations: selectedDestinations,
            // searchQuery: searchQuery,
            // phoneSearchQuery: phoneSearchQuery,
            selectedStartDate: selectedStartDate,
            selectedEndDate: selectedEndDate,
            selectedUpdatedAtStartDate: selectedUpdatedAtStartDate,
            selectedUpdatedAtEndDate: selectedUpdatedAtEndDate,
            selectedIntakeYear: selectedIntakeYear,
            selectedIntakeMonth: selectedIntakeMonth
        });
    };

    const getAssignedToValue = () => {
        if (currentScreen === "Staff" && currentUser?.uid) {
            return [currentUser.uid];
        }

        if (currentScreen === "Manager" && selectedAssigneeOptions.length === 0 && managerTeamOptions?.length > 0) {
            return managerTeamOptions;
        }

        if (selectedAssigneeOptions.length > 0) {
            return selectedAssigneeOptions;
        }

        return undefined; // or return undefined if you want to skip the query constraint
    };

    async function fetchLeadsdata(
        isLoadingMore = false,
        pageNum?: number,
        // Add parameters for filter values that might be updated
        overrideFilters?: {
            selectedLeadSources?: any[],
            selectedLeadStates?: any[],
            selectedLeadStages?: any[],
            selectedLeadStatuses?: any[],
            selectedAdmissionStatuses?: any[],
            selectedWelcomeCallByAdmissionTeamStatuses?: any[],
            selectedVisaProcessingStatuses?: any[],
            selectedApplicationMovedStatuses?: any[],
            selectedConditionalOfferLetterStatuses?: any[],
            selectedUnConditionalOfferLetterStatuses?: any[],
            selectedFeePaymentStatuses?: any[],
            selectedFileSubmissionStatuses?: any[],
            selectedFollowUpStatuses?: any[],
            selectedSubAgentOptions?: any[],
            selectedCampaignOptions?: any[],
            selectedPrefferedStreams?: any[],
            selectedDestinations?: any[],
            searchQuery?: string,
            phoneSearchQuery?: string,
            selectedStartDate?: any[],
            selectedEndDate?: any[],
            selectedUpdatedAtStartDate?: any[],
            selectedUpdatedAtEndDate?: any[],
            selectedIntakeYear?: any[],
            selectedIntakeMonth?: any[]
        }
    ) {
        // Only prevent duplicate load-more requests
        if (isLoadingMore && loading) return;

        setLoading(true);
        const pageToFetch = pageNum !== undefined ? pageNum : currentPage;

        try {
            const startTime = new Date();
            const assignedTo = await getAssignedToValue();
            const auth = getAuth();

            if (!auth.currentUser) {
                console.error('User not logged in');
                return;
            }

            // Cursor-based pagination logic
            let direction: 'first' | 'next' | 'prev' = 'first';
            let cursorId: string | undefined = undefined;
            if (pageToFetch === 1) {
                direction = 'first';
            } else if (pageToFetch > currentPage) {
                direction = 'next';
                cursorId = lastDocument?.id;
            } else if (pageToFetch < currentPage) {
                direction = 'prev';
                cursorId = leadsData[0]?.id;
            }

            if (!cursorId && pageToFetch > 1) {
                cursorId = sessionStorage.getItem('cursorId') || '';
            }

            console.log("Fetching leads data for page:", cursorId);

            // Use override values if provided, otherwise use current state
            const filters = overrideFilters || {};

            const result = await fetchLeads(db, auth.currentUser, {
                pageSize: pageSize,
                direction,
                cursorId,
                isActive: isStaff && currentScreen === "Staff" ? true : undefined,
                sourceIds: filters.selectedLeadSources ?? selectedLeadSources,
                stateIds: filters.selectedLeadStates ?? selectedLeadStates,
                stageIds: filters.selectedLeadStages ?? selectedLeadStages,
                statusIds: filters.selectedLeadStatuses ?? selectedLeadStatuses,
                admissionStatusIds: filters.selectedAdmissionStatuses ?? selectedAdmissionStatuses,
                welcomeCallStatusIds: filters.selectedWelcomeCallByAdmissionTeamStatuses ?? selectedWelcomeCallByAdmissionTeamStatuses,
                visaProcessStatusIds: filters.selectedVisaProcessingStatuses ?? selectedVisaProcessingStatuses,
                applicationStatusIds: filters.selectedApplicationMovedStatuses ?? selectedApplicationMovedStatuses,
                conditionalOfferLetterStatusIds: filters.selectedConditionalOfferLetterStatuses ?? selectedConditionalOfferLetterStatuses,
                unconditionalOfferLetterStatusIds: filters.selectedUnConditionalOfferLetterStatuses ?? selectedUnConditionalOfferLetterStatuses,
                feePaymentStatusIds: filters.selectedFeePaymentStatuses ?? selectedFeePaymentStatuses,
                fileSubmissionStatusIds: filters.selectedFileSubmissionStatuses ?? selectedFileSubmissionStatuses,
                activeFollowUpIds: filters.selectedFollowUpStatuses ?? selectedFollowUpStatuses,
                assignedTo: assignedTo,
                subAgent: filters.selectedSubAgentOptions ?? selectedSubAgentOptions,
                campaignIds: filters.selectedCampaignOptions ?? selectedCampaignOptions,
                preferredStreamIds: filters.selectedPrefferedStreams ?? selectedPrefferedStreams,
                destinationIds: filters.selectedDestinations ?? selectedDestinations,
                // searchValue: (filters.searchQuery ?? searchQuery).length > 2 ? (filters.searchQuery ?? searchQuery) : '',
                // phoneValue: (filters.phoneSearchQuery ?? phoneSearchQuery).length > 2 ? (filters.phoneSearchQuery ?? phoneSearchQuery) : '',
                startDate: (filters.selectedStartDate ?? selectedStartDate).length > 0 ? convertToFirebaseTimestamp((filters.selectedStartDate ?? selectedStartDate)[0], true) : null,
                endDate: (filters.selectedEndDate ?? selectedEndDate).length > 0 ? convertToFirebaseTimestamp((filters.selectedEndDate ?? selectedEndDate)[0], false) : null,
                updatedAtStartDate: (filters.selectedUpdatedAtStartDate ?? selectedUpdatedAtStartDate).length > 0 ? convertToFirebaseTimestamp((filters.selectedUpdatedAtStartDate ?? selectedUpdatedAtStartDate)[0], true) : null,
                updatedAtEndDate: (filters.selectedUpdatedAtEndDate ?? selectedUpdatedAtEndDate).length > 0 ? convertToFirebaseTimestamp((filters.selectedUpdatedAtEndDate ?? selectedUpdatedAtEndDate)[0], false) : null,
                intakeYear: filters.selectedIntakeYear ?? selectedIntakeYear,
                intakeMonth: filters.selectedIntakeMonth ?? selectedIntakeMonth,
                orderByField: "updatedAt",
                sortDirection: "desc"
            });

            const response = result.data;
            setLeadsData(response?.leads || []);
            setHasMore(response?.hasMore);
            setLastDocument(response?.lastDocument);
            setTotalLeadsCount(response?.count);

            // Check if we should update the selectCurrentPage state based on current selections
            const currentPageLeadIds = response?.leads.map(lead => lead.id) || [];
            // if (currentPageLeadIds.length > 0) {
            //     const allCurrentPageLeadsSelected = currentPageLeadIds.every(id =>
            //         selectedLeadsForAction.includes(id)
            //     );
            //     setSelectCurrentPage(allCurrentPageLeadsSelected);
            // }

            if (response?.leads.length === 0) {
                setToastMessage("No leads found for the selected filters");
                setShowToast(true);
                setTimeout(() => {
                    setShowToast(false);
                }, 3000);
            }

            const endTime = new Date();
            const timeDiff = endTime.getTime() - startTime.getTime();
            console.log("Time taken to fetch leads data:", timeDiff, "ms");
        } catch (error) {
            console.error('Failed to fetch leads:', error);
        } finally {
            setLoading(false);
        }
    }

    // Initial load
    useEffect(() => {
        if (firstEffectDone) {
            // Always start with page 1 when filters change
            setCurrentPage(1);
            fetchPageData(1);
        }
    }, [firstEffectDone, managerTeamOptions, selectedLeadSources, selectedLeadStates, selectedLeadStages, selectedLeadStatuses,
        selectedAdmissionStatuses, selectedWelcomeCallByAdmissionTeamStatuses, selectedVisaProcessingStatuses,
        selectedApplicationMovedStatuses, selectedConditionalOfferLetterStatuses, selectedUnConditionalOfferLetterStatuses,
        selectedFeePaymentStatuses, selectedFileSubmissionStatuses, selectedSubAgentOptions, selectedFollowUpStatuses, selectedAssigneeOptions, selectedCampaignOptions,
        selectedPrefferedStreams, selectedDestinations, selectedIntakeMonth, selectedIntakeYear, selectedStartDate, selectedEndDate, selectedUpdatedAtStartDate, selectedUpdatedAtEndDate, pageSize]);

    const loadMore = () => {
        if (!hasMore || loading) return;
        fetchLeadsdata(true);
    };

    const getTotalFilters = () => {
        const filterCount =
            selectedLeadSources.length +
            selectedLeadStates.length +
            selectedLeadStages.length +
            selectedLeadStatuses.length +
            selectedAdmissionStatuses.length +
            selectedWelcomeCallByAdmissionTeamStatuses.length +
            selectedVisaProcessingStatuses.length +
            selectedApplicationMovedStatuses.length +
            selectedConditionalOfferLetterStatuses.length +
            selectedUnConditionalOfferLetterStatuses.length +
            selectedFeePaymentStatuses.length +
            selectedFileSubmissionStatuses.length +
            selectedFollowUpStatuses.length +
            selectedAssigneeOptions.length +
            selectedCampaignOptions.length +
            selectedPrefferedStreams.length +
            selectedDestinations.length +
            selectedStartDate.length +
            selectedEndDate.length +
            selectedSubAgentOptions.length +
            selectedUpdatedAtStartDate.length +
            selectedUpdatedAtEndDate.length +
            selectedIntakeMonth.length +
            selectedIntakeYear.length;

        return filterCount > 0 ? filterCount : 0;
    };

    const handleExcelExport = async (selectedColumns: string[]) => {
        setDownloadLoading(true);
        try {
            const assignedTo = getAssignedToValue;
            const auth = getAuth();
            const excel = await exportLeadsToExcel(db, auth.currentUser, {
                pageSize: 10,
                sourceIds: selectedLeadSources,
                stateIds: selectedLeadStates,
                stageIds: selectedLeadStages,
                statusIds: selectedLeadStatuses,
                admissionStatusIds: selectedAdmissionStatuses,
                welcomeCallStatusIds: selectedWelcomeCallByAdmissionTeamStatuses,
                visaProcessStatusIds: selectedVisaProcessingStatuses,
                applicationStatusIds: selectedApplicationMovedStatuses,
                conditionalOfferLetterStatusIds: selectedConditionalOfferLetterStatuses,
                unconditionalOfferLetterStatusIds: selectedUnConditionalOfferLetterStatuses,
                feePaymentStatusIds: selectedFeePaymentStatuses,
                fileSubmissionStatusIds: selectedFileSubmissionStatuses,
                subAgent: selectedSubAgentOptions,
                activeFollowUpIds: selectedFollowUpStatuses,
                campaignIds: selectedCampaignOptions,
                preferredStreamIds: selectedPrefferedStreams,
                destinationIds: selectedDestinations,
                updatedAtStartDate: selectedUpdatedAtStartDate.length > 0 ? convertToFirebaseTimestamp(selectedUpdatedAtStartDate[0], true) : null,
                updatedAtEndDate: selectedUpdatedAtEndDate.length > 0 ? convertToFirebaseTimestamp(selectedUpdatedAtEndDate[0], true) : null,
                startDate: selectedStartDate.length > 0 ? convertToFirebaseTimestamp(selectedStartDate[0], true) : null,
                endDate: selectedEndDate.length > 0 ? convertToFirebaseTimestamp(selectedEndDate[0], false) : null,
                intakeYear: selectedIntakeYear.length > 0 ? selectedIntakeYear : undefined,
                intakeMonth: selectedIntakeMonth.length > 0 ? selectedIntakeMonth : undefined,
                orderByField: "updatedAt",
                sortDirection: "desc"
            }, selectedColumns);

            const url = window.URL.createObjectURL(new Blob([excel]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Leads_${new Date().toISOString().slice(0, 10)}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Failed to export leads:', error);
        } finally {
            setDownloadLoading(false);
            setShowExportModal(false);
        }
    };

    const showToastMessage = (message: string, isError: boolean = false) => {
        setToastMessage(message);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
    };

    const handleFetchFollowUp = async (leadId: string, followUpId: string | null | undefined) => {
        // If we're already viewing the follow-up details for this lead, hide them
        if (currentViewingFollowUpId === leadId) {
            setCurrentViewingFollowUpId(null);
            return;
        }

        // If there's no follow-up ID, nothing to fetch
        if (!followUpId) {
            return;
        }

        try {
            // If we've already fetched this follow-up, just show it
            if (followUpDetails[leadId]) {
                setCurrentViewingFollowUpId(leadId);
                return;
            }

            const followUpsQuery = query(
                collection(db, `companies/${companyId}/followUps`),
                where(documentId(), '==', followUpId)
            );

            const followUpsSnapshot = await getDocs(followUpsQuery);
            const followUp = followUpsSnapshot.docs[0]?.data();

            if (followUp) {
                setFollowUpDetails(prev => ({
                    ...prev,
                    [leadId]: followUp
                }));
                setCurrentViewingFollowUpId(leadId);
            }
        } catch (error) {
            console.error(`Error fetching follow-up details for lead ${leadId}:`, error);
            // Show error toast
            setToastMessage(`Error fetching follow-up details: ${(error as Error).message}`);
            setShowError(true);
            setShowToast(true);
            setTimeout(() => {
                setShowToast(false);
                setShowError(false);
            }, 3000);
        }
    };

    // Add state for follow up details and current viewing follow up id
    const [followUpDetails, setFollowUpDetails] = useState<{ [leadId: string]: any }>({});
    const [currentViewingFollowUpId, setCurrentViewingFollowUpId] = useState<string | null>(null);

    return (
        <div className="min-h-screen bg-gray-200">
            <div className="fixed top-16 left-0 h-full z-10">
                <SideNavbar />
            </div>

            <div className={`${isCollapsed ? 'ml-[70px]' : 'ml-[290px]'} mt-[109px] p-8 transition-all duration-300 w-[calc(100%-${isCollapsed ? '70px' : '290px'})]`}>
                <div className="bg-white p-6 rounded-3xl shadow-md">
                    <div className="flex items-center gap-6 mb-8">
                        <div className="flex items-center justify-center w-14 h-14 rounded-full" style={{ background: 'linear-gradient(180deg, #00A6D9 0%, #3483BE 100%)' }}>
                            <img src={`${process.env.PUBLIC_URL}/images/desktop/ph_student.svg`} alt="Lead Icon" />
                        </div>
                        <h2 className="text-2xl font-medium text-black"> Lead Report </h2>

                        {activeTab === 'custom' && currentScreen === 'Admin' && (
                            <div className="ml-auto flex items-center gap-4">
                                <button
                                    onClick={() => handleExcelExport(selectedColumns)}
                                    disabled={downloadLoading}
                                    className="px-4 py-2 text-white font-semibold rounded-full flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    style={{
                                        background: 'linear-gradient(180deg, #FFA782 0%, #FC583D 100%)',
                                        fontFamily: 'Montserrat',
                                        fontSize: '20px',
                                        fontWeight: 500,
                                        lineHeight: '24.38px',
                                    }}
                                >
                                    {downloadLoading ? (
                                        <>
                                            Downloading...
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                        </>
                                    ) : (
                                        <>
                                            Export
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/desktop/sidebaricon/report-svgrepo-com-white.svg`}
                                                alt="Export Icon"
                                                className="w-4 h-4"
                                            />
                                        </>
                                    )}
                                </button>

                            </div>
                        )}
                    </div>
                    <div className="flex space-x-1 mb-4">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${activeTab === tab.id ? 'bg-gradient-to-r from-[#3483BE] to-[#02385E] text-white' : 'text-gray-500 hover:bg-gray-50'}`}>
                                {tab.label}
                            </button>
                        ))}
                    </div>


                    {/* collapsible filter settings */}
                    <div className={`mt-4 mb-8 border border-gray-200 rounded-lg relative z-[5] p-4`}>
                        {activeTab === 'custom' && (
                            <div
                                className="flex items-center cursor-pointer justify-between"
                                onClick={() => setIsCollapsedFilter(!isCollapsedFilter)}
                            >
                                <span className="flex flex-col mr-2 font-semibold">Filters</span>
                                <span className="flex items-center gap-2">
                                    {getTotalFilters() > 0 && (
                                        <a
                                            href="#"
                                            className="text-xs text-blue-500 font-normal mr-2"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                clearAllFilters(e);
                                            }}
                                        >
                                            Clear All Filters
                                        </a>
                                    )}

                                    <span className="text-xs text-gray-500 font-normal mr-6">
                                        {getTotalFilters()} Filters Applied
                                    </span>

                                    <span
                                        className="text-sm transition-transform duration-300 ease-in-out"
                                        style={{ transform: isCollapsedFilter ? 'rotate(0deg)' : 'rotate(180deg)' }}
                                    >
                                        ▲
                                    </span>
                                </span>
                            </div>
                        )}

                        <div
                            className={`transition-all duration-300 ease-in-out transform origin-top ${isCollapsedFilter
                                ? 'max-h-[1000px] opacity-100 scale-y-100'
                                : 'overflow-hidden max-h-0 opacity-0 scale-y-95'
                                }`}
                        >
                            <div className="pt-4">
                                <SettingsBoxesLayout tabId={activeTab} />
                            </div>
                        </div>
                    </div>

                    {activeTab === 'custom' && (
                        <>
                            {/* Pagination Control - Top */}
                            <div className="flex items-center justify-between mt-6 mb-4">
                                <div className="flex items-center gap-4">
                                    <div className="flex items-center">
                                        <label className="text-xs text-gray-500 mr-2" >Rows per page:</label>
                                        <select
                                            value={pageSize}
                                            onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                                            className="border border-gray-200 rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        >
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                        </select>
                                    </div>
                                    <div className="ml-2 relative">
                                        <button
                                            className="text-white text-xs font-semibold flex items-center gap-2 bg-[#3483BE] p-1 rounded"
                                            onClick={() => setCustomizeOpen(!customizeOpen)}
                                        >
                                            <img src={`${process.env.PUBLIC_URL}/images/desktop/customize.svg`} alt="Add Staff Icon" className="w-5 h-5" />
                                        </button>
                                        {customizeOpen && (
                                            <div className="absolute top-full mt-1 right-0 bg-white shadow-lg rounded-lg p-4 z-10">
                                                <div className="flex flex-col gap-2">
                                                    {Object.keys(customTableProps).map((key) => (
                                                        <div key={key} className="flex items-center justify-between">
                                                            <label className="text-xs font-semibold text-gray-500 ml-2 whitespace-nowrap">{key}</label>
                                                            <button
                                                                className={`ml-2 text-xs p-1 rounded ${leadManagementDashboardProps[customTableProps[key as keyof typeof customTableProps]] ? 'bg-green-100' : 'bg-pink-100'}`}
                                                                onClick={() => {
                                                                    dispatch(setDashboardProps({ key: customTableProps[key as keyof typeof customTableProps], value: !leadManagementDashboardProps[customTableProps[key as keyof typeof customTableProps]] }));
                                                                }}
                                                            >
                                                                {leadManagementDashboardProps[customTableProps[key as keyof typeof customTableProps]] ? 'Hide' : 'Show'}
                                                            </button>
                                                        </div>
                                                    ))}
                                                    <button className="text-xs text-red-500 font-semibold mt-2"
                                                        onClick={() => {
                                                            dispatch(reset());
                                                            setCustomizeOpen(false);
                                                        }}
                                                    >
                                                        Reset to Default
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Navigation buttons (centered) */}
                                <div className="flex-1 flex items-right justify-end gap-2">
                                    {/* first */}
                                    <button
                                        onClick={() => handlePageChange(1)}
                                        disabled={loading || currentPage === 1}
                                        className="px-2 py-1 border border-[#609ac7] rounded-md text-sm bg-white text-[#32a6ff] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        &lt;&lt;
                                    </button>

                                    {/* prev */}
                                    <button
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={loading || currentPage === 1}
                                        className="px-2 py-1 border border-[#609ac7] rounded-md text-sm bg-white text-[#32a6ff] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        &lt;
                                    </button>

                                    {/* page number */}
                                    <div className="px-2 py-1 border border-[#609ac7] rounded-md text-sm bg-white text-[#32a6ff]">
                                        {currentPage}
                                    </div>

                                    {/* next */}
                                    <button
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={loading || !hasMore || (currentPage === Math.ceil(totalLeadsCount / pageSize))}
                                        className="px-2 py-1 border border-[#609ac7] rounded-md text-sm bg-white text-[#32a6ff] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        &gt;
                                    </button>
                                </div>

                                {/* Page count (right-aligned) */}
                                <div className="flex-1 text-right">
                                    <div className="text-xs text-gray-500">
                                        {loading ? 'Loading...' : `(Total: ${totalLeadsCount} Leads) ${currentPage} / ${totalPages} pages`}
                                    </div>
                                </div>
                            </div>
                            <div className="rounded-xl overflow-hidden shadow-lg">
                                <div className="overflow-x-auto relative">
                                    {loading ? (
                                        <TableSkeleton columns={8} rows={5} />
                                    ) : (
                                        <table className="min-w-full table-auto border-collapse">
                                            <thead>
                                                <tr className="bg-gradient-to-r from-[#02385E] to-[#02385E]/90">
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Total ({totalLeadsCount})
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Name
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Phone Number
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Created At
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Source
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Campaign Name
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Assignee To
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Stage
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">
                                                        Priority
                                                    </th>
                                                    <th className="px-4 py-3 text-sm font-semibold text-white tracking-wider whitespace-nowrap border-r border-[#ffffff20]">
                                                        Follow Up
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {loading ? (
                                                    Array(10).fill(0).map((_, index) => (
                                                        <tr key={index} className={`transition-colors duration-150 ease-in-out ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}`}>
                                                            {Array(9).fill(0).map((_, colIndex) => (
                                                                <td key={colIndex} className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100">
                                                                    <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    leadsData.map((lead, index) => (
                                                        <tr key={lead.id} style={{ color: lead.isNewEntry ? 'black' : 'inherit' }}
                                                            className={`
                                            transition-colors duration-150 ease-in-out
                                            ${index % 2 === 0 ? 'bg-white hover:bg-blue-50' : 'bg-slate-50 hover:bg-blue-50'}
                                          `}
                                                        >
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                                                                {lead.name}
                                                                {lead.isActive === false && (
                                                                    <span className="text-xs bg-red-100 text-red-800 ml-2 py-1 px-2 rounded">
                                                                        Inactive
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                                                                {lead.number}
                                                            </td>
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                                                                {lead.createdAt
                                                                    ? new Date(convertToDate(lead.createdAt)).toLocaleDateString("en-US", {
                                                                        month: "short",
                                                                        day: "numeric",
                                                                        year: "numeric",
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })
                                                                    : ""}
                                                            </td>
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                                                                {sources.find((src) => src.id === lead.sourceId)?.source ||
                                                                    (lead.isNewEntry ? "--" :
                                                                        (lead.sourceId ? "--" : "--"))}
                                                            </td>
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                                                                {campaignOptions.find((camp) => camp.id === lead.campaignId)?.data?.campaign || "--"}
                                                            </td>
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                                                                {assigneeOptions.find((assigneeOption) => assigneeOption.id === lead.assignedTo)?.data?.name || "--"}
                                                            </td>
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                                                                {stages.find((stage) => stage.id === lead.stageId)?.stage || "--"}
                                                            </td>
                                                            <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                                                                <div className="flex items-center gap-2">
                                                                    <span className={`w-3 h-3 rounded-full ${getStatusCircleColor(statuses.find((status) => status.id === lead.statusId)?.status || "--")}`}></span>
                                                                    {statuses.find((status) => status.id === lead.statusId)?.status || "--"}
                                                                </div>
                                                            </td>
                                                            <td className="p-2 text-center whitespace-nowrap border-r border-gray-100">
                                                                {lead.hasActiveFollowUp ? (
                                                                    <span
                                                                        className="text-xs font-semibold text-[#3483BE] cursor-pointer"
                                                                        onClick={() => handleFetchFollowUp(lead.id, lead.activeFollowUpId)}
                                                                    >
                                                                        {currentViewingFollowUpId === lead.id && followUpDetails[lead.id] ? (
                                                                            new Date(convertToDate(followUpDetails[lead.id].followUpTime)).toLocaleDateString("en-US", {
                                                                                month: "short",
                                                                                day: "numeric",
                                                                                year: "numeric",
                                                                                hour: "2-digit",
                                                                                minute: "2-digit",
                                                                            })
                                                                        ) : "Yes"}
                                                                    </span>
                                                                ) : (
                                                                    <span className="text-xs font-bold text-gray-500">No</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                            {/* Pagination Control - Top */}
                            <div className="flex items-center justify-between mt-6">
                                <div className="flex items-center gap-4">
                                    <div className="flex items-center">
                                        <label className="text-xs text-gray-500 mr-2">Rows per page:</label>
                                        <select
                                            value={pageSize}
                                            onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                                            className="border border-gray-200 rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        >
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                        </select>
                                    </div>
                                    <div className="mr-8">

                                    </div>
                                </div>
                                {/* Navigation buttons (centered) */}
                                <div className="flex-1 flex items-right justify-end gap-2">
                                    {/* first */}
                                    <button
                                        onClick={() => handlePageChange(1)}
                                        disabled={loading || currentPage === 1}
                                        className="px-2 py-1 border border-[#609ac7] rounded-md text-sm bg-white text-[#32a6ff] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        &lt;&lt;
                                    </button>

                                    {/* prev */}
                                    <button
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={loading || currentPage === 1}
                                        className="px-2 py-1 border border-[#609ac7] rounded-md text-sm bg-white text-[#32a6ff] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        &lt;
                                    </button>

                                    {/* page number */}
                                    <div className="px-2 py-1 border border-[#609ac7] rounded-md text-sm bg-white text-[#32a6ff]">
                                        {currentPage}
                                    </div>

                                    {/* next */}
                                    <button
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={loading || !hasMore || (currentPage === Math.ceil(totalLeadsCount / pageSize))}
                                        className="px-2 py-1 border border-[#609ac7] rounded-md text-sm bg-white text-[#32a6ff] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        &gt;
                                    </button>
                                </div>

                                {/* Page count (right-aligned) */}
                                <div className="flex-1 text-right">
                                    <div className="text-xs text-gray-500">
                                        {loading ? 'Loading...' : `(Total: ${totalLeadsCount} Leads) ${currentPage} / ${totalPages} pages`}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            {isReportPopupOpen && reportType && (
                <ReportModals reportType={reportType} onClose={closePopup} />
            )}
            {showToast && (
                <Toast
                    message={toastMessage}
                    isError={
                        toastMessage.includes('Error') ||
                        toastMessage.includes('Cannot') ||
                        toastMessage.includes('Failed')
                    }
                    show={showToast}
                    onClose={() => setShowToast(false)}
                />
            )}
        </div>
    );
};

function timeConverter(UNIX_timestamp: number): string {
    const a = new Date(UNIX_timestamp * 1000);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const year = a.getFullYear();
    const month = months[a.getMonth()];
    const date = a.getDate();
    const hour = a.getHours();
    const min = a.getMinutes();
    // const sec = a.getSeconds();
    const time = `${date} ${month} ${year} ${hour}:${min}`;
    return time;
}

// Convert date's time to start and end of the day
const convertToFirebaseTimestamp = (
    date: string | Date,
    isStartDate: boolean = true
): Timestamp => {
    const dateObj = new Date(date);

    if (isStartDate) {
        dateObj.setHours(5, 30, 0, 0);
    } else {
        dateObj.setDate(dateObj.getDate() + 1);
        dateObj.setHours(5, 29, 59, 999);
    }

    console.log('dateObj', dateObj);


    return Timestamp.fromDate(dateObj);
};

export default Reports;

function setShowExportModal(arg0: boolean) {
    throw new Error("Function not implemented.");
}
